import { VideoPlayerProvider } from './videoPlayerProvider';
import { isCurrentAudioMovie } from '../../../store/current-video/selectors';
import { getState } from '../../../store';
import { AudioPlayerProvider } from './audioPlayerProvider';
import { ICaptionsItem } from '../../../types/common';

export interface IPlayerProvider {
  play(): void;
  getCurrentTime(): Promise<number>;
  pause(): void;
  seek(): void;
  getTargetCaptions(): ICaptionsItem[];
  getActiveTargetCaptionIndex(): Promise<number>;
  isPaused(): boolean;
  isPlay(): boolean;
}

const audioProvider = new AudioPlayerProvider();
const videoProvider = new VideoPlayerProvider();

export class PlayerProvider {

  private static isAudioProvider(): boolean {
    return isCurrentAudioMovie(getState());
  }

  public static getProvider(): IPlayerProvider {
    return this.isAudioProvider() ? audioProvider : videoProvider;
  }

}